import { ChangeDetectionStrategy, Component, Renderer2, inject, input } from '@angular/core';
import { ContentBlockBaseComponent } from '../content-block-base/content-block-base.component';

import { CookieNgrxModule } from '@teamfoster/sdk/cookie-ngrx';
import { TextUtilityModule, UrlRewritePipe } from '@teamfoster/sdk/text-utility';
import { ButtonModule } from '@teamfoster/sdk/button';

import { ContentBlockListInfo } from '../../models';

@Component({
  selector: 'app-content-block-anchor-nav',
  templateUrl: './content-block-anchor-nav.component.html',
  styleUrls: ['./content-block-anchor-nav.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CookieNgrxModule, TextUtilityModule, ButtonModule],
  providers: [UrlRewritePipe],
})
export class ContentBlockAnchorNavComponent extends ContentBlockBaseComponent {
  private renderer = inject(Renderer2);
  blocks = input.required<ContentBlockListInfo[]>();
  debug = input<boolean>(false);
  urlRewritePipe = inject(UrlRewritePipe);

  scrollToBlock(anchor: string) {
    if (!anchor) {
      return;
    }
    const fragment = this.urlRewritePipe.transform(anchor);

    if (this.blocks().find(i => i.anchor === fragment)) {
      const element = this.renderer.selectRootElement('#' + fragment, true);

      if (element) {
        const yOffset = 100 * -1; // Your offset value
        const yPosition = element.getBoundingClientRect().top + window.scrollY + yOffset;

        window.scrollTo({
          top: yPosition,
          behavior: 'smooth',
        });
      }
    }
  }
}
